/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import queryString from 'query-string';
import { useShallow } from 'zustand/react/shallow';
import { DateRangeKey } from '@newo/ui-kit';
import { TSessionFilters } from '@/pages/Sessions/Sessions.types';
import useSessionsStore from '@/pages/Sessions/Sessions.store';
import { stringToBoolean } from '@/utils/filters';

const parseQueryParams = (searchParams: URLSearchParams) => {
    return queryString.parse(searchParams.toString());
};

const URLListener = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const { replaceFilters, setDateRange } = useSessionsStore(
        useShallow((state) => ({
            replaceFilters: state.replaceFilters,
            setDateRange: state.setDateRange
        }))
    );

    useEffect(() => {
        const isEmptySearchParams = Array.from(searchParams).length === 0;
        if (isEmptySearchParams) return;

        const { is_lead, is_opportunity, is_test, channels, session_lengths } =
            parseQueryParams(searchParams);

        const filters = {
            channels: (channels ?? []) as string[],
            session_lengths: (session_lengths ?? []) as string[],
            is_opportunity: stringToBoolean(is_opportunity?.toString()),
            is_lead: stringToBoolean(is_lead?.toString()),
            is_test: stringToBoolean(is_test?.toString())
        } satisfies TSessionFilters;

        replaceFilters(filters);
        setDateRange(DateRangeKey.LAST_30_DAYS);

        setSearchParams({}, { replace: true });
    }, []);

    return false;
};

export default URLListener;
